const splitFirstOccurrence = (str, separator) => {
  const [first, ...rest] = str.split(separator)

  const remainder = rest.join(separator)

  return [first, remainder]
}

export default splitFirstOccurrence
